import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export type { ClassValue };

/**
 * Class name joiner with Tailwind conflict resolution.
 *
 * `twMerge` makes the `className` a caller passes win over the class a primitive
 * already sets for the same property — so `<Button className="rounded-[12px]">`
 * really does change the radius instead of producing two competing rules.
 *
 * Uses `clsx` and `tailwind-merge`, both already app dependencies.
 */
export function cn(...values: ClassValue[]): string {
    return twMerge(clsx(values));
}
